import { render, staticRenderFns } from "./RoomContent.vue?vue&type=template&id=d60de816&scoped=true&"
import script from "./RoomContent.vue?vue&type=script&lang=js&"
export * from "./RoomContent.vue?vue&type=script&lang=js&"
import style0 from "./RoomContent.vue?vue&type=style&index=0&id=d60de816&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60de816",
  null
  
)

export default component.exports